import React, { useState } from "react";
import CareerContext from "./CareerContext";
import { randomStr } from "../../../utils/helper";

const CareerState = (props) => {
  const [apiData, setApiData] = useState({ data: [], isLoading: false });
  const [apiDataOurTeam, setApiDataOurTeam] = useState({
    isLoading: false,
    data: [],
  });
  const [skill, setSkill] = useState([
    { id: randomStr(2), skill: "", parentageOfSkill: "" },
  ]);
  const [isBackgroundColor, setIsBackgroundColor] = useState(false);
  const [collId, setCollId] = useState();
  const [fromData, setFormData] = useState({
    title: "",
    subTitle: "",
    navMapId: "",
    webId: localStorage.getItem("webId"),
    theme: 1,
    isTitleShow: true,
    style: {
      ".career-section": {
        padding: "100px 0",
        "background-color": "rgb(255 255 255 / 100)",
      },
      ".career-section .section-title-area": {
        "margin-bottom": "50px",
      },
      ".career-section.bg-image": {
        "background-image": "",
      },
      ".career-section.bg-image::before": {
        "background-color": "",
      },
      ".career-section .section-title-area .section-subtitle": {
        "font-size": "16px",
        "font-weight": "600",
        color: "rgb(255 73 124 / 100)",
        display: "inline-block",
        "background-color": "rgb(255 73 124 / 0.2)",
        padding: "5px 20px",
        "border-radius": "15px",
        "margin-bottom": "15px",
      },
      ".career-section .section-title-area .section-title": {
        "font-size": "44px",
        "font-weight": "600",
        color: "rgb(0 0 0 / 100)",
      },
      ".career-section .feature-list": {
        padding: "20px",
        margin: "10px 0",
        "background-color": "rgb(255 255 255 / 100)",
        "box-shadow": "0 0px 15px rgb(0 0 0 / 0.188)",
        shadowColor: "rgb(0 0 0 / 0.188)",
        "border-radius": "0px",
      },
      ".career-section .feature-list h5": {
        "font-size": "20px",
        "font-weight": "600",
        color: "rgb(255 73 124 / 100)",
        "margin-bottom": "10px",
      },
      ".career-section .feature-list p": {
        "font-size": "16px",
        "font-weight": "normal",
        color: "rgb(102 102 102 / 100)",
        "line-height": "1.4",
        "text-align": "justify",
      },
      ".contact-form-div .btn.btn-submit": {
        color: "rgb(255 255 255 / 100)",
        "background-color": "rgb(255 73 124 / 100)",
        "border-color": "rgb(255 73 124 / 100)",
      },
    },
  });

  const [formDataChild, setFormDataChild] = useState({
    title: "",
    subTitle: "",
    description: "",
    isTitleShow: true,
    order: 1,
    webId: localStorage.getItem("webId"),
    navMapId: "",
  });

  const [backImageToggle, setBackImageToggle] = useState(false);

  const [settingFormData, setSettingFormData] = useState({
    ".career-section": {
      padding: "100px 0",
      "background-color": "rgb(255 255 255 / 100)",
    },
    ".career-section .section-title-area": {
      "margin-bottom": "50px",
    },
    ".career-section.bg-image": {
      "background-image": "",
    },
    ".career-section.bg-image::before": {
      "background-color": "",
    },
    ".career-section .section-title-area .section-subtitle": {
      "font-size": "16px",
      "font-weight": "600",
      color: "rgb(255 73 124 / 100)",
      display: "inline-block",
      "background-color": "rgb(255 73 124 / 0.2)",
      padding: "5px 20px",
      "border-radius": "15px",
      "margin-bottom": "15px",
    },
    ".career-section .section-title-area .section-title": {
      "font-size": "44px",
      "font-weight": "600",
      color: "rgb(0 0 0 / 100)",
    },
    ".career-section .feature-list": {
      padding: "20px",
      margin: "10px 0",
      "background-color": "rgb(255 255 255 / 100)",
      "box-shadow": "0 0px 15px rgb(0 0 0 / 0.188)",
      shadowColor: "rgb(0 0 0 / 0.188)",
      "border-radius": "0px",
    },
    ".career-section .feature-list h5": {
      "font-size": "20px",
      "font-weight": "600",
      color: "rgb(255 73 124 / 100)",
      "margin-bottom": "10px",
    },
    ".career-section .feature-list p": {
      "font-size": "16px",
      "font-weight": "normal",
      color: "rgb(102 102 102 / 100)",
      "line-height": "1.4",
      "text-align": "justify",
    },
    ".contact-form-div .btn.btn-submit": {
      color: "rgb(255 255 255 / 100)",
      "background-color": "rgb(255 73 124 / 100)",
      "border-color": "rgb(255 73 124 / 100)",
    },
    careerId: "",
  });
  const [boxSection, setBoxSection] = useState(false);
  const [id, setId] = useState("");
  const [childId, setChildId] = useState("");
  const [navMapId, setNavMapId] = useState("");
  const [galleryImgId, setGalleryImgId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isParent, setIsParent] = useState(false);
  const [filter, setFilter] = useState("");
  const [theme, setTheme] = useState(1);
  const [imgShow, setImgShow] = useState(false);
  const [sectionPageName, setSectionPageName] = useState("");
  return (
    <CareerContext.Provider
      value={{
        apiData,
        setApiData,
        apiDataOurTeam,
        setApiDataOurTeam,
        fromData,
        setFormData,
        id,
        setId,
        isEdit,
        setIsEdit,
        filter,
        setFilter,
        skill,
        galleryImgId,
        setGalleryImgId,
        setSkill,
        settingFormData,
        setSettingFormData,
        formDataChild,
        setFormDataChild,
        isParent,
        setIsParent,
        childId,
        setChildId,
        navMapId,
        setNavMapId,
        backImageToggle,
        setBackImageToggle,
        collId,
        setCollId,
        boxSection,
        setBoxSection,
        isBackgroundColor,
        setIsBackgroundColor,
        theme,
        setTheme,
        imgShow,
        setImgShow,
        sectionPageName,
        setSectionPageName,
      }}
    >
      {props.children}
    </CareerContext.Provider>
  );
};

export default CareerState;
